import DynamicForm from './DynamicForm';
import DynamicInput from './DynamicInput';

export default function (Vue, options = {}) {
    Vue.component('sau-dynamic-form', DynamicForm);
    Vue.component('sau-dynamic-input', DynamicInput);
}
